import styled from "styled-components";

export const Container = styled.div`
  @media screen and (max-width: 820px) {
    width: 100%;
  }
  width: 70%;
  padding: 20px 10px;
  h2 {
    margin: 20px 0;
    font-size: 20px;
    color: #5D6679;
    text-transform: capitalize;
    padding-bottom: 20px;
    border-bottom: solid 1px #F0F1F3;
  }
  .profile {
    margin-top: 30px;
    padding: 5px;
    display: flex;
    gap: 20px;
    margin-bottom: 10px;
    .circled {
      background-color: #03a9f4;
      border-radius: 50%;
      padding: 10px;
      font-size: 20px;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 60px;
      height: 60px;
    }
    .texts {
      margin-top: 10px;
      h3 {
        font-size: 20px;
        color: #48505E;
        text-transform: capitalize;
      }
      p {
        margin-top: 5px;
        font-size: 12px;
        color: #667085;
      }
    }
  }
  .footer {
    .logout {
      width: 150px;
      display: flex;
      gap: 5px;
      margin-bottom: 30px;
      cursor: pointer;
    }
    .deactivate {
      width: 200px;
      cursor: pointer;
    }
    p {
      color: #F04438;
      font-size: 18px;
    }
  }
`;

export const Wrapper = styled.div`
  @media screen and (max-width: 500px) {
    grid-template-columns: repeat(1, 1fr);
    padding: 20px;
    gap: 30px;
  }
  padding: 25px 10px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
  h4 {
    color: #48505E;
    font-size: 16px;
  }
  p {
    margin-top: 10px;
    font-size: 14px;
    color: #667085;
  }
`;